/**
 * 负库存统计配置
 * 表头/表格字段固化在本地，抽离为独立文件
 */

import { getLoginName } from '@/utils/util'

export const BILL_TYPE = 'MINUS_STOCK'
export const REPORT_TITLE = '负库存统计'

// 表格列定义（10列）
export const defColumns = [
  {
    title: '序号',
    dataIndex: 'rowIndex',
    width: 50,
    align: 'center',
    customRender: function (t, r, index) {
      return (t !== '合计') ? (parseInt(index) + 1) : t
    }
  },
  { title: '仓库名称', dataIndex: 'depotName', width: 100, ellipsis: true },
  { title: '条码', dataIndex: 'barCode', width: 120, ellipsis: true },
  { title: '名称', dataIndex: 'name', width: 150, ellipsis: true },
  { title: '规格', dataIndex: 'standard', width: 80, ellipsis: true },
  { title: '型号', dataIndex: 'model', width: 80, ellipsis: true },
  { title: '颜色', dataIndex: 'color', width: 60, ellipsis: true },
  { title: '单位', dataIndex: 'unit', width: 50, ellipsis: true },
  { title: '单价', dataIndex: 'purchaseDecimal', width: 80, align: 'right' },
  { title: '当前库存', dataIndex: 'currentNumber', width: 90, align: 'right' }
]

// 打印数据构建 - 将列表数据映射为打印字段
export function buildPrintData(dataSource, queryParam, userInfo, companyInfo) {
  // 提取合计行
  const totalRow = (dataSource || []).find(item => item.rowIndex === '合计')

  // 过滤合计行，映射数据行
  const rows = (dataSource || [])
    .filter(item => item.rowIndex !== '合计')
    .map((item, idx) => ({
      rowIndex: idx + 1,
      depotName: item.depotName || '',
      barCode: item.barCode || '',
      name: item.name || '',
      standard: item.standard || '',
      model: item.model || '',
      color: item.color || '',
      unit: item.unit || '',
      purchaseDecimal: item.purchaseDecimal || 0,
      currentNumber: item.currentNumber || 0
    }))

  // 追加合计行到表格末尾
  if (totalRow) {
    rows.push({
      rowIndex: '合计',
      depotName: '',
      barCode: '',
      name: '',
      standard: '',
      model: '',
      color: '',
      unit: '',
      purchaseDecimal: '-',
      currentNumber: totalRow.currentNumber || 0
    })
  }

  return {
    reportTitle: REPORT_TITLE,
    reportDate: new Date().toLocaleDateString(),
    dateRange: (queryParam && queryParam.beginTime && queryParam.endTime)
      ? queryParam.beginTime + ' ~ ' + queryParam.endTime : '',
    table: rows,
    total_currentNumber: 0,
    creatorName: getLoginName(),
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || '',
    companyFax: (companyInfo && companyInfo.companyFax) || ''
  }
}